var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"content-class":"user-menu-mobile-dialog","transition":"dialog-top-transition"},model:{value:(_vm.isShowed),callback:function ($$v) {_vm.isShowed=$$v},expression:"isShowed"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }